import Mask from "./mask";

export const mask = Mask.directive;

export default {
  install(Vue) {
    Vue.directive(Mask.name, Mask.directive);
  }
};
